import React from "react";
import Board from "./Compnents/Board";

const Game = () => {
    return (
        <div>
            <h1 className="text">Tic-Tac-Toe</h1>
            <Board />
            <a href="https://github.com/codewithbharat/tic-tac-toe">View Source Code On Github</a>
        </div>
    )
}

export default Game;